var SvgIcon = require("app/ui/SvgIcon"),
    icons   = require("app/theme/icons"),
    kind    = require("enyo/kind");

require("app/ui/Spinner.less");

module.exports = kind(/** @lends  app.ui.Spinner.prototype */ {

    /**
     * @private
     */
    name: "app.ui.Spinner",

    /**
     * @private
     */
    kind: SvgIcon,

    /**
     * @private
     */
    classes: "app-ui-spinner",

    /**
     * The id used to reference an icon from the icon-sprite.
     *
     * @type  {?string}
     * @public
     */
    icon: icons["app.ui.Spinner"]

});
